import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:shadow-lg"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - 欧美三级影视详情`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-950/80 px-2 py-1 text-xs font-semibold text-accent-300 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-primary-700 backdrop-blur-sm">
          {movie.region}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-secondary-500">{movie.titleEn}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-2.5">
          <span className="text-xs font-medium text-foreground-600">{movie.year}</span>
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-800"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}